import { get } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { ICulturalVocCard } from '../types/content';

export default class CulturalVocCardModel extends BaseModel {
  constructor(options: IModelOptions & { culturalVocId: number }) {
    super(options);
    this.loadItemEdit(options.culturalVocId);
  }

  async loadItemData(id: number) {
    const culturalVocCards = await get<ICulturalVocCard[]>(`culturalvocs/${id}/card`);
    return { cardData: culturalVocCards[0] };
  }
}